import React, { useRef, useState } from "react";
import { Box, makeStyles } from "@material-ui/core";

import { useSelector } from "react-redux";
import { getAuthInfo } from "store/slices/auth";

import Loading from "components/Common/Loading";
import { useTranslation } from "react-i18next";
import ChangePasswordForm from "./Components/ChangePasswordForm";
import ChangeEmailForm from "./Components/ChangeEmailForm";
import { changeEmail, changePassword, getMe } from "store/slices/auth";
import { useDispatch } from 'react-redux';
import EmailAlertForm from "./Components/EmailAlertForm";
import { SYSTEM_ROLE } from "config/AppConfig";
import CompanyUserDetailForm from "views/Admin/Component/CompanyUser/Components/CompanyUserDetailForm";
import ScrollableTabs from "components/CustomTabs/AppTabsScroll";
// import AccountingAccountForm from "views/Company/AccountSetting/Components/AccountingAccountForm";

const AccountSetting = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const cpRef = useRef();
  const ceRef = useRef();

  const [loading, setLoading] = useState(false);
  const authInfo = useSelector(getAuthInfo) || {};
  const { role, id, email, socialLogin } = authInfo;

  if (!role) {
    return (<Loading />);
  }

  const styles = makeStyles(() => ({
    subLabel: {
      marginBottom: '0.5rem',
      fontSize: '0.8rem'
    }
  }));
  const classes = styles();

  const submitChangePassword = async ({ confirmPass, newPass }) => {
    setLoading(true);
    if (confirmPass && newPass) {
      const result = await dispatch(changePassword({
        id: id,
        confirmPass: confirmPass,
        newPass: newPass
      }));
      if (result.payload) {
        cpRef && cpRef.current.resetForm();
        // dispatch(getMe());
      }
    }
    setLoading(false);
  };
  const submitChangeEmail = async ({ email }) => {
    setLoading(true);
    if (email) {
      const result = await dispatch(changeEmail({
        id: id,
        email: email.trim()
      }));
      if (result.payload) {
        ceRef && ceRef.current.resetForm();
        dispatch(getMe());
      }
    }
    setLoading(false);
  };

  const tabs = [
    {
      tabLabel: t('label.changePassword'),
      tabContent: <React.Fragment>
        <ChangeEmailForm
          isSubmitting={loading}
          email={email}
          onSubmit={submitChangeEmail}
          formRef={ceRef}
        />
        <Box className={classes.subLabel}>
          {t('text.leavePasswordBlank')}
        </Box>
        <ChangePasswordForm
          isSubmitting={loading}
          onSubmit={submitChangePassword}
          formRef={cpRef}
        />
      </React.Fragment>
    },
    {
      tabLabel: t('label.emailAlerts'),
      tabContent: <EmailAlertForm />
    }
  ];

  const companyTabs = [
    {
      tabLabel: t('label.user_profile'),
      tabContent: <CompanyUserDetailForm />,
    },
    {
      tabLabel: t('label.changePassword'),
      tabContent: <React.Fragment>
        <Box className={classes.subLabel}>
          {t('text.leavePasswordBlank')}
        </Box>
        <ChangePasswordForm
          isSubmitting={loading}
          onSubmit={submitChangePassword}
          formRef={cpRef}
        />
      </React.Fragment>
    },
    {
      tabLabel: t('label.emailAlerts'),
      tabContent: <EmailAlertForm />
    }, 
    // {
    //   tabLabel: t('label.accountingAccount'),
    //   tabContent: <AccountingAccountForm />
    // }
  ];
  const companySocialTabs = [
    {
      tabLabel: t('label.user_profile'),
      tabContent: <CompanyUserDetailForm />,
    },
    {
      tabLabel: t('label.emailAlerts'),
      tabContent: <EmailAlertForm />
    },
    // {
    //   tabLabel: t('label.accountingAccount'),
    //   tabContent: <AccountingAccountForm />
    // }
  ]

  return (
    <ScrollableTabs swipeable={false} tabs={authInfo.role === SYSTEM_ROLE.COMPANY ? socialLogin ? companySocialTabs : companyTabs : tabs} isFullWidth={true}/>
  );
}

export default AccountSetting;
